import axios from "axios";
import UrlHelper from "../utilities/UrlHelper";

class BannersService {
    getBanners () {
        const getUrl = "banners";
        return axios.get(UrlHelper.getIdentifiApiUrl() + getUrl);
    }
}

export default new BannersService();
